module.exports = __webpack_public_path__ + "static/img/zzsj.2c464a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zzsj.jpg
// module id = 06/J
// module chunks = 1